export default {"src":"/_next/static/media/grundriss-modern.f70accba.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};